import { Component, Input, OnInit, ElementRef } from '@angular/core';

export interface UserComment {
  comment: string;
  createdDate: Date | string;
  commentType: number;
}

export interface UserCommentsData {
  userName: string;
  userEmail: string;
  comments: UserComment[];
}

@Component({
  selector: 'app-user-comments-modal',
  templateUrl: './user-comments-modal.component.html',
  styleUrls: ['./user-comments-modal.component.css']
})
export class UserCommentsModalComponent implements OnInit {
  @Input() commentsData: UserCommentsData | null = null;
  isLoading = true;

  constructor(public el: ElementRef) { }

  ngOnInit(): void {
    ($(this.el.nativeElement).find('#userCommentsModal') as any).on('hidden.bs.modal', () => {
      this.isLoading = true;
      this.commentsData = null;
    });
  }

  open(commentsData: UserCommentsData) {
    this.isLoading = true;
    this.commentsData = null;
    ($(this.el.nativeElement).find('#userCommentsModal') as any).modal('show');

    setTimeout(() => {
      this.commentsData = commentsData;
      this.isLoading = false;
    }, 300);
  }

  close() {
    ($(this.el.nativeElement).find('#userCommentsModal') as any).modal('hide');
  }
}